import { Fragment } from "react";
import bgImage from "../assets/images/sampleDrawing.webp";
import HeroSection from "../components/HeroSection";
import DocumentList from "../components/DocumentList";

const SampleDrawings = () => {
    const drawingsContent = "Our Steel Detailing Services consist of preparing the complete and accurate fabrication drawings for all steel elements of the structural frame"
    return (
        <Fragment>
            <HeroSection title="Sample Drawings" backgroundImage={bgImage} content={drawingsContent} style={{marginTop:"1rem"}}/>
            <DocumentList />
        </Fragment>
    );
}

export default SampleDrawings;